import { css } from 'aphrodite';
import { DangerIcon } from '../../components/svgs/icons/DangerIcon';
import { InfoIcon } from '../../components/svgs/icons/InfoIcon';
import { SuccessCheckIcon } from '../../components/svgs/icons/SuccessCheckIcon';
import { styleSheet, toneIconStyles, toneStyles } from './styles';

export type AlertTone = 'info' | 'success' | 'warning' | 'danger';

export type AlertProps = AphroditeStyled<React.ComponentProps<'div'>> & {
	tone?: AlertTone;
	icon?: React.ReactNode;
};

const DEFAULT_ICONS: Record<AlertTone, React.ReactNode> = {
	info: <InfoIcon fillColor='currentColor' />,
	success: <SuccessCheckIcon size={16} fillColor='currentColor' ringColor='transparent' />,
	warning: <DangerIcon backgroundColor='currentColor' borderColor='transparent' strokeWidth='0' />,
	danger: <DangerIcon backgroundColor='currentColor' borderColor='transparent' strokeWidth='0' />,
};

export function Alert({ tone = 'info', icon = DEFAULT_ICONS[tone], children, styles = [], ...props }: AlertProps) {
	return (
		<div
			data-slot='alert'
			data-tone={tone}
			role={tone === 'danger' ? 'alert' : 'status'}
			className={css(styleSheet.root, toneStyles[tone], ...styles)}
			{...props}
		>
			{icon ? (
				<span data-slot='alert-icon' aria-hidden='true' className={css(styleSheet.icon, toneIconStyles[tone])}>
					{icon}
				</span>
			) : null}
			{children}
		</div>
	);
}

export function AlertTitle({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'p'>>) {
	return <p data-slot='alert-title' className={css(styleSheet.title, ...styles)} {...props} />;
}

export function AlertDescription({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) {
	return <div data-slot='alert-description' className={css(styleSheet.description, ...styles)} {...props} />;
}

export function AlertActions({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) {
	return <div data-slot='alert-actions' className={css(styleSheet.actions, ...styles)} {...props} />;
}
